/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_FrontrowInputs */

const en_nav_frontrow = /** @type {(inputs: Nav_FrontrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frontrow`)
};

/**
* | output |
* | --- |
* | "Frontrow" |
*
* @param {Nav_FrontrowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_frontrow = /** @type {((inputs?: Nav_FrontrowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_FrontrowInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_frontrow(inputs)
});